import { render, staticRenderFns } from "./transformer-detect.vue?vue&type=template&id=231ef2a6&scoped=true&"
import script from "./transformer-detect.vue?vue&type=script&lang=js&"
export * from "./transformer-detect.vue?vue&type=script&lang=js&"
import style0 from "./transformer-detect.vue?vue&type=style&index=0&id=231ef2a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231ef2a6",
  null
  
)

export default component.exports